import { autoinject } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { MeasurementSystems } from "./measurement-systems";
import { PressureConverter } from "./pressure-value";

@autoinject
export class PressureFormatValueConverter {
	constructor(private i18n: I18N) { }

	toView(value: number) {

		if (isNaN(value)) {
			return this.i18n.tr("offline");
		}
		let measurementSystem = localStorage.getItem("measurement-system");
		if (!measurementSystem) {
			measurementSystem = MeasurementSystems.imperial;
		}

		switch (measurementSystem) {
		case MeasurementSystems.metric:
			return `${value.toFixed(2)} kPa`;
		default:
			const pressure = PressureConverter.toImperial(value);
			return `${pressure.toFixed(2)} psi`;
		}

	}
}